import { useTranslation } from '@/lib/i18n/i18n.client';
import { Text } from '@/components/atoms/Text';

import ProductCardUseCase from './ProductCardUseCase';
import { ProductCardUseCaseProps } from './types';

type Props = {
  useCases: ProductCardUseCaseProps[];
};

export default function ProductCardUseCases({ useCases }: Props) {
  const { texts } = useTranslation();

  return (
    <div data-tracker-component='use-cases'>
      <Text
        color='gray-600'
        variant='label-medium'
        classNames={{ wrapper: 'dark:text-gray-dark-400 mb-2' }}
      >
        {texts.product_cards.use_cases}
      </Text>
      <div className='flex flex-col gap-4'>
        {useCases.map((useCase) => (
          <ProductCardUseCase key={useCase.id} useCase={useCase} />
        ))}
      </div>
    </div>
  );
}
